import React, { Component } from "react";
import { inject } from "mobx-react";
import { Button } from "react-bootstrap";
import "./FullProfileComponent.css";

const IS_BIRD_APP = process.env.REACT_APP_ENV === "bird";

@inject("searchStore", "http")
export default class FullProfileComponent extends Component {
  handleClick = () => {
    const { shoulPageReload } = this.props;
    this.props.searchStore.setFullProfile();
    if (shoulPageReload) window.location.reload();
  };

  render() {
    const {
      selectedUserProfileId,
      type,
      customMessage,
      styleOverrides,
      shouldDisplay,
    } = this.props;

    if (
      selectedUserProfileId === "full" ||
      IS_BIRD_APP ||
      shouldDisplay === false
    )
      return null;

    const message =
      customMessage ||
      (type === "Framework"
        ? "Missing something ? Try the "
        : "Not visible ? Try the ");

    return (
      <div className={"full-profile-container"} style={styleOverrides}>
        <span>{message} </span>
        <Button className="full-profile-button" onClick={this.handleClick}>
          Full Profile
        </Button>
      </div>
    );
  }
}
